<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    mini-variant-width="80"
    width="262"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>
          <v-img :src="require(`@/assets/${'PriBlanco1600x800.png'}`)" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list dense>
      <base-item :item="profile" />
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapState } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'Tablero principal',
          to: '/',
        },
        {
          group: '/ver',
          title: 'Jugadores',
          gate: 'M_jugadores',
          children: [
            { title: 'Jugadores', to: 'jugadores', gate: 'M_jugadores' },
            { title: 'Contratos', to: 'jugador/lista_contratos', gate: 'M_contratos' },
            { title: 'Vencimientos', to: 'Vencimientos', gate: 'M_contratos' },
          ],
        },
        {
          group: '/ver',
          title: 'Scouting',
          gate: 'M_scouting',
          children: [
            { title: 'Jugadores en seguimiento', to: 'scouting', gate: 'M_scouting' },
          ],
        },
        {
          group: '/ver',
          title: 'Legales',
          gate: 'M_legales',
          children: [
            { title: 'Abiertos', to: 'legales/litigios', gate: 'M_legales' },
            { title: 'Cerrados', to: 'legales/litigiosCerrados', gate: 'M_legales' },
          ],
        },
        {
          group: '/ver',
          title: 'Consultas Profesionales',
          children: [
            { title: 'Turnos Asignados', to: 'consultasMedicas' },
            { title: 'Turnos Pendientes', to: 'consultasPendientes' },
            { title: 'Solicitar Turno', to: 'turno', gate: 'M_consultas_turno' },
          ],
        },
        {
          group: '/ver',
          title: 'Informes',
          gate: 'M_informes',
          children: [
            { title: 'Listado', to: 'informes', gate: 'M_informes' },
            { title: 'Pendientes', to: 'informesPendientes', gate: 'M_informes' },
          ],
        },
        {
          group: '/ver',
          title: 'Pedidos Mercado',
          gate: 'M_pedidos',
          children: [
            { title: 'Abiertos', to: 'pedidos', gate: 'M_pedidos' },
            { title: 'Cerrados', to: 'pedidosCerrados', gate: 'M_pedidos' },
          ],
        },
        {
          group: '/ver',
          title: 'Ingresos',
          gate: 'M_cobros',
          children: [
            { title: 'Cobros', to: 'contabilidad/cobros', gate: 'M_cobros' },
            { title: 'Facturas', to: 'facturas', gate: 'M_cobros' },
            { title: 'Cobros pendientes', to: 'contabilidad/cobros_pendientes', gate: 'M_cobros' },
          ],
        },
        {
          group: '/ver',
          title: 'Egresos',
          gate: 'M_pagos',
          children: [
            {
              title: 'Pagos',
              to: 'contabilidad/pagos/lista',
              gate: 'M_pagos',
            },
            {
              title: 'Facturas proveedores',
              to: 'facturasp',
              gate: 'M_pagos',
            },
            {
              title: 'Obligaciones pendientes',
              to: 'contabilidad/pagos_pendientes',
              gate: 'M_pagos',
            },
          ],
        },
        {
          group: '/ver',
          title: 'Cuenta corriente',
          gate: 'M_resumen',
          children: [
            { title: 'Resumen Jugador', to: 'cuentaCorrienteJugador', gate: 'M_resumen' },
            { title: 'Resumen Cuenta Corriente', to: 'cuentaCorrienteResumen', gate: 'M_resumen' },
          ],
        },
        {
          group: '/ver',
          title: 'Solicitud Extraordinaria',
          gate: 'M_viaticos',
          children: [
            {
              title: 'Listados',
              to: 'viaticos',
              gate: 'M_viaticos',
            },
          ],
        },
        {
          group: '/alta',
          title: 'Parametrizaciones',
          gate: 'M_parametros',
          children: [
            { title: 'Staff', to: 'staff', gate: 'M_parametros' },
            { title: 'Ligas', to: 'ligas', gate: 'M_parametros' },
            { title: 'Club', to: 'club', gate: 'M_parametros' },
            { title: 'Contactos', to: 'contacto', gate: 'M_contactos' },
            { title: 'Cuenta Bancaria', to: 'cuentaBancaria', gate: 'M_parametros' },
            { title: 'Cargos', to: 'cargos', gate: 'M_parametros' },
            { title: 'Tipos de Contrato', to: 'tipo_contratos', gate: 'M_parametros' },
            { title: 'Banco', to: 'banco', gate: 'M_parametros' },
            { title: 'Tarjeta', to: 'tarjeta', gate: 'M_parametros' },
            { title: 'Sponsor', to: 'sponsor', gate: 'M_parametros' },
            { title: 'Roles', to: 'roles', gate: 'M_parametros' },
          ],
        },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),

      currentUser () {
        return this.$store.state.idUsuario
      },

      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },

      computedItems () {
        // return this.items.map(this.mapItem)
        return this.items
      },

      profile () {
        return {
          avatar: false,
          group: '',
          title: this.$store.state.nombreUsuario,
          children: [

          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
